import {useParams, useRouteMatch} from 'react-router-dom';
import {UserPlaylists} from '../../../../../../../components/user-playlists/user-playlists';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {useAuth} from '../../../../../../../contexts/auth/context';
import {RolePermissionType} from '../../../../../../../backend/enums/role-permission-type';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../i18n/translations';
import {ScreenPaths} from '../../../../../../../enums';

export default function SeniorPlaylistsProfessionalCaregiverOfficeScreen() {
  const officeContext = useOffice();
  const {t} = useTranslation();
  const {hasWritePermission} = useAuth();
  let {id, entityId}: {id?: string; entityId?: string} = useParams();
  const userName = (officeContext.state.userForm?.user.displayName ||
    officeContext.state.userForm?.user.name)!;
  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  const canWritePlaylists = hasWritePermission(
    RolePermissionType.Seniors_DigitalInclusion_Playlists
  );

  return (
    <UserPlaylists
      caregiverMode={CaregiverMode.Professional}
      canWrite={canWritePlaylists}
      userId={id || ''}
      entityId={entityId || ''}
      userName={userName || ''}
      playlistRowBaseLinkUrl={url}
      headerTitleCrumbs={[
        {
          label: t(translations.screen_paths.professional_caregiver_seniors),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
        },
        {
          label: userName || '',
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
        },
        {
          label: t(translations.role_permissions_section['digital-inclusion']),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_DigitalInclusion}`,
        },
        {
          label: t(translations.screen_paths.senior_playlists),
          link: url,
        },
      ]}
    />
  );
}
